// frontend/src/config.js
const isLocalhost = Boolean(
  typeof window !== 'undefined' &&
  (window.location.hostname === 'localhost' ||
   window.location.hostname === '127.0.0.1' ||
   window.location.hostname.startsWith('192.168.') ||
   window.location.hostname.startsWith('10.'))
);

export const API_BASE_URL = process.env.REACT_APP_API_URL || (
  isLocalhost
    ? `http://${typeof window !== 'undefined' && window.location.hostname ? window.location.hostname : 'localhost'}:8000/api`
    : (typeof window !== 'undefined' ? `${window.location.protocol}//${window.location.host}/api` : 'https://itapoasign.camaraitapoa.sc.gov.br/api')
);
